/**
 * EcsCard — full detail card for ECS cluster in Resource Grid view.
 */
import type { EcsCluster } from '@/types';
import { StatusBadge } from '../primitives/StatusBadge';
import styles from './EcsCard.module.css';

export interface EcsCardProps {
  cluster: EcsCluster;
}

export function EcsCard({ cluster }: EcsCardProps) {
  return (
    <article
      className={styles.card}
      aria-label={`ECS cluster ${cluster.clusterName}`}
    >
      <header className={styles.header}>
        <span className={styles.clusterName} title={cluster.clusterName}>
          {cluster.clusterName}
        </span>
        <span className={styles.badge}>ECS</span>
      </header>

      <div className={styles.meta}>
        <div className={styles.field}>
          <span className={styles.fieldLabel}>Status</span>
          <span className={styles.fieldValue}>{cluster.clusterStatus}</span>
        </div>
        <div className={styles.field}>
          <span className={styles.fieldLabel}>Services</span>
          <span className={styles.fieldValue}>{cluster.services.length}</span>
        </div>
        <div className={styles.field}>
          <span className={styles.fieldLabel}>Region</span>
          <span className={styles.fieldValue}>{cluster.region}</span>
        </div>
        <div className={styles.field}>
          <span className={styles.fieldLabel}>Account</span>
          <span className={styles.fieldValue}>{cluster.accountId}</span>
        </div>
      </div>

      {cluster.services.length > 0 && (
        <section className={styles.services}>
          <h3 className={styles.servicesHeading}>Services</h3>
          <ul className={styles.serviceList} role="list">
            {cluster.services.map((svc) => (
              <li key={svc.serviceName} className={styles.serviceRow}>
                <StatusBadge status={svc.serviceStatus} size="sm" label={svc.serviceName} />
                <span className={styles.serviceCounts}>
                  {svc.runningCount}/{svc.desiredCount} tasks
                </span>
              </li>
            ))}
          </ul>
        </section>
      )}
    </article>
  );
}
